import ImageCloudHistoryService from "@app/services/http/image.cloud.history.service";
import { ImageCloudHistory } from "@app/types";
import { formatDate } from "@app/utils/util";
import useObservable from "@core/hooks/use-observable.hook";
import { useEffect, useState } from "react";

function CloudImageHistory() {
  const [cloudImageHistory, setCloudImageHistory] = useState<
    ImageCloudHistory[]
  >([]);

  const queryParams = new URLSearchParams(window.location.search);
  const image_id = queryParams.get("image_id");

  const { subscribeOnce } = useObservable();

  useEffect(() => {
    image_id &&
      subscribeOnce(
        ImageCloudHistoryService.getImageCloudHistory(image_id, 1),
        (res) => {
          // setCloudImageHistory(res);
        }
      );
  }, [image_id]);

  return (
    <div>
      <table className="min-w-full leading-normal">
        <thead className="text-white">
          <tr className="border-b-2 border-gray-200 bg-[#409EFF] text-sm">
            <th className="p-3 text-left w-40">Time Start</th>
            <th className="p-3 text-left w-40">Time Shutdown</th>
            <th className="p-3 text-left w-40">Sử dụng</th>
          </tr>
        </thead>
        <tbody>
          {cloudImageHistory.map((history) => (
            <tr key={history._id}>
              <td className="p-3">{formatDate(history.time_start)}</td>
              <td className="p-3">
                {history.time_shutdown
                  ? formatDate(history.time_shutdown)
                  : "Chưa shutdown"}
              </td>
              <td className="p-3">
                {history.time_shutdown
                  ? (() => {
                      const diff =
                        new Date(history.time_shutdown).getTime() -
                        new Date(history.time_start).getTime();
                      const hours = Math.floor(diff / 1000 / 60 / 60);
                      const minutes = Math.floor((diff / 1000 / 60) % 60);

                      return `${hours} giờ : ${minutes
                        .toString()
                        .padStart(2, "0")} phút`;
                    })()
                  : "Chưa shutdown"}
              </td>
            </tr>
          ))}
        </tbody>
        {cloudImageHistory.length === 0 && (
          <tfoot>
            <tr>
              <td colSpan={3} className="p-3 text-center">
                Không có dữ liệu
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}

export default CloudImageHistory;
